/* eslint-disable import-x/no-cycle */
import { RuntimeConfiguration } from './app/ConfigurationProvider';
import { Agent, ScheduleElementTag } from './graphql/components';

import type { CalendarDateTime } from '@internationalized/date';

declare global {
  interface Window {
    ENV: RuntimeConfiguration['env'];
  }
}

export type NullableNumber = number | null;

export const CreateEditView = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
} as const;

export type CreateEditViewType = Values<typeof CreateEditView>;

export const SortOrder = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
} as const;

export type SortOrderType = Values<typeof SortOrder>;

export const sortAgentsBy: Record<string, Array<keyof Agent>> = {
  name: ['name', 'surname'],
  surname: ['surname', 'name'],
};

export interface ActionRouteType {
  action: CreateEditViewType;
}

export interface IdRouteType {
  id: string;
}

export type DateType = Date | number | string;

export type RecordBooleanType = Record<string, boolean>;

// defines props shared across my schedule and scheduling composer scenes
export interface CommonScheduleElement {
  start: number;
  end: number;
  scheduleElementName: string;
  scheduleElementNameSize: number;
  y?: number;
  key: string;
  color: string;
  scheduleElementId: string;
  paidTimeOff: boolean;
  paid: boolean;
  productive: boolean;
  tags: ScheduleElementTag[];
}

export type RangeFilter = {
  min?: number;
  max?: number;
};

export type RadioFilter = string | undefined;

export type RadioInputOption = {
  value: string;
  label: string;
};

// helper type to define types of const notations.
export type Values<T> = T[keyof T];

export type DateRange = {
  start: CalendarDateTime;
  end: CalendarDateTime;
} | null;

// ----------------------------------------------------------------------------
// GraphQL related types (imported through codegen.yml)
// ----------------------------------------------------------------------------
type AdherenceHistoryPerDay = {
  earlyLeaves: boolean;
  lateArrivals: boolean;
  outOfAdhEventsCount: number;
  scheduledTime: number;
  scheduledWorkingTime: number;
  outOfAdhTimeTotal: number;
};

export type RecordAdherenceHistoryPerDay = Record<string, AdherenceHistoryPerDay>;
export type ChartData = [number, null | number];

export type AdherenceHistorySidebarFilter = {
  adherenceEventsRange: RangeFilter;
  conformanceRange: RangeFilter;
  earlyLeaves: boolean;
  inAdherenceRange: RangeFilter;
  includeInactiveAgents: boolean;
  lateArrivals: boolean;
};

export const ReportsKpiType = {
  ADHERENCE: 'adherence',
  CONFORMANCE: 'conformance',
} as const;

export type ReportsStatistics = Record<Values<typeof ReportsKpiType>, number | string>;
